import { useWrapAsync } from "@paroicms/front-app-log";
import { useState } from "react";
import { Link } from "react-router-dom";
import type { Reference } from "../../../../api/infrastructure/reference.formatter";
import useGetReferences from "../../../hooks/useGetReferences";
import { dayJsFormat } from "../../../shared/global-tools/dayjs.helpers";
import Navbar from "../../parts/Navbar/Navbar";
import Icon from "../../utils/Icons/Icon";
import OurDataView from "../../utils/OurDataView/OurDataView";
import SearchInput from "../../utils/SearchInput/SearchInput";
import DatabaseCard from "./DatabaseCard";
import "./index.scss";

// TODO: Finish the page

export default function DatabaseListPage() {
  const { references, refreshReferences, searchReferences } = useGetReferences({
    preloadData: false,
  });
  const [searchValue, setSearchValue] = useState("");
  // const [total, setTotal] = useState<number>();
  const wrapAsync = useWrapAsync();

  const handleSearchDatabase = async () => {
    await searchReferences(searchValue);
  };
  // const handleFetchDatabases = async (options: {
  //   limit: number;
  //   page: number;
  // }) => {
  //   await apiRequestWrapper(async () => {
  //     const result = await fetchDatabases(options);
  //     setData(result.data);
  //     setTotal(result.pagination?.total ?? result.data.length);
  //   });
  // };

  return (
    <div className="DatabaseListPage">
      <Navbar pageTitle="Liste des référentiels" />

      <div className="DatabaseListPage Container">
        <div className="Container-content">
          <div className="DatabaseListPage-header">
            <SearchInput
              value={searchValue}
              onChange={(value) => setSearchValue(value)}
              onSearch={wrapAsync(handleSearchDatabase)}
              onClear={wrapAsync(() => refreshReferences({ limit: 10, page: 1 }))}
            />

            <Link to={"/app/databases/create"} className="Btn primary icon link">
              <Icon name="plus" color="#fff" /> Ajouter
            </Link>
          </div>
          <OurDataView<Reference>
            data={references}
            total={references.length}
            loadData={refreshReferences}
            itemTemplate={(reference) => (
              <DatabaseCard
                key={reference.id}
                route={`/app/databases/${reference.id}/view`}
                label={reference.name ?? ""}
                fields={reference.columnNumber}
                rows={reference.lineNumber}
                date={reference.createdAt ? dayJsFormat(reference.createdAt, "DD/MM/YYYY") : "N/A"}
                status={reference.databaseGenerated ? "validate" : "in-progress"}
              />
            )}
          />
        </div>
      </div>
    </div>
  );
}
